package kz.dentalcrm.app.data.network

import io.ktor.client.HttpClient
import io.ktor.client.request.header
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.HttpMethod
import io.ktor.http.contentType
import io.ktor.http.headers
import io.ktor.http.path
import kotlinx.serialization.Serializable
import kz.dentalcrm.app.core.network.handle
import kz.dentalcrm.app.core.storage.Storage
import kz.dentalcrm.app.data.network.response_model.quick_replies.QuickReply

class QuickRepliesApi(
    private val httpClient: HttpClient,
    private val storage: Storage,
) {
    suspend fun getQuickReplies(page: Int = 1) = httpClient.handle<List<QuickReply>?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path("api/v1/patients/quick-replies")
        }
        method = HttpMethod.Get
    }

    suspend fun addQuickReply(message: String) = httpClient.handle<Any?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path("api/v1/patients/quick-replies")
            setBody(AddQuickReplyRequest(message = message))
        }
        method = HttpMethod.Post
    }

    suspend fun updateQuickReply(id: Int, message: String) = httpClient.handle<Any?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path("api/v1/patients/quick-replies/${id}")
            setBody(UpdateQuickReplyRequest(id = id, message = message))
        }
        method = HttpMethod.Put
    }

    suspend fun deleteQuickReply(id: Int) = httpClient.handle<Any?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path("api/v1/patients/quick-replies/${id}")
            setBody(DeleteQuickReplyRequest(id = id))
        }
        method = HttpMethod.Delete
    }
}

@Serializable
private data class AddQuickReplyRequest(val message: String)

@Serializable
private data class UpdateQuickReplyRequest(val id: Int, val message: String)

@Serializable
private data class DeleteQuickReplyRequest(val id: Int)
